import { memo, useMemo } from "react";

import type { VoucherForCampaign } from "@/lib/gql/__generated__/graphql";

import { BlankContentForList } from "@/components/features/_components";
import { ListTableHeader } from "@/components/features/items/edit/_shared/ui/components/system/list/list-table-header";
import { ItemListContainer } from "@/components/features/items/edit/_shared/ui/components/system/list/list-wrapper";

import { Table, TableBody, TableCaption } from "@/components/ui/table/table";

import { CampaignTableHeader } from "./header";
import { CampaignTableRow, SAMPLE_CAMPAIGN_ID } from "./row";

type Props = {
	voucherForCampaignList: VoucherForCampaign[];

	onDeleteVoucher: (voucherID: string, voucherName: string, inSale: boolean) => void;

	navigateToCreateNewCampaignPage: () => void;
	navigateToEditOrDetailsPage: (voucherID: string, inSale: boolean) => void;
};

export const CampaignListTableRoot = memo(
	({
		voucherForCampaignList,

		onDeleteVoucher,

		navigateToCreateNewCampaignPage,
		navigateToEditOrDetailsPage,
	}: Props) => {
		/**
		 * キャンペーンの一覧を表示するか
		 */
		const canShowCampaignList = useMemo(() => voucherForCampaignList.length > 0, [voucherForCampaignList.length]);

		return (
			<ItemListContainer
				header={
					<ListTableHeader
						createNewItemList={[
							{
								title: "キャンペーンの作成",
								handleClick: () => navigateToCreateNewCampaignPage(),
							},
						]}
					/>
				}
				tableBody={
					<Table>
						<TableCaption>キャンペーンの一覧</TableCaption>
						{canShowCampaignList ? (
							<>
								<CampaignTableHeader />
								<TableBody>
									{voucherForCampaignList.map((campaign) => {
										const { voucherID, inSale, name } = campaign;

										const isSampleCampaign = voucherID === SAMPLE_CAMPAIGN_ID;
										const handleClickDeleteButton =
											!inSale && !isSampleCampaign
												? () => onDeleteVoucher(voucherID, name, inSale)
												: undefined;

										return (
											<CampaignTableRow
												key={voucherID}
												campaign={campaign}
												navigateToEditOrDetailsPage={navigateToEditOrDetailsPage}
												iconButtonActionsList={{
													onClickEditButton: undefined,
													onClickCopyButton: undefined,
													onClickDeleteButton: handleClickDeleteButton,
													onClickOpenButton: undefined,
												}}
											/>
										);
									})}
								</TableBody>
							</>
						) : (
							<BlankContentForList
								content={`キャンペーンがありません。\n新規作成ボタンからキャンペーンを作成してください。`}
							/>
						)}
					</Table>
				}
			/>
		);
	},
);

CampaignListTableRoot.displayName = "CampaignListTableRoot";
